// @flow
/* eslint-disable camelcase */
import React from 'react';

import { withTranslation, WithTranslation } from 'react-i18next';
import { compose, withProps } from 'recompose';
import { withScriptjs } from 'react-google-maps';
import config from '../../config';
import FormFieldWrapper from './FormFieldWrapper';

const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_MAPS_API_KEY}&libraries=places`;

export type PlacesResultObject = {
  street_number?: String,
  route?: String,
  locality?: String,
  postal_code?: String,
  administrative_area_level_1?: String
};

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => any,
  value: string,
  requiredValues: string[],
  setValues: (values: Object) => any,
  label: string,
  className: string
} & WithTranslation

class MapInput extends React.Component {
  props: Props;

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  cleanupGooglePlacesDOM = () => {
    const elements = document.getElementsByClassName('pac-container');
    if (elements.length > 0) {
      const googleElement = elements[0];
      googleElement.remove();
    }
  };

  componentWillUnmount() {
    this.cleanupGooglePlacesDOM();
  }

  componentDidMount() {
    const { t } = this.props;

    const google = window.google;
    if (google) {
      const autoComplete = new google.maps.places.Autocomplete(this.inputRef.current, {
        componentRestrictions: { country: ['CA'] },
        types: ['address']
      });
      autoComplete.setFields(['address_component']);

      const onPlaceChange = () => {
        const place = autoComplete.getPlace();
        if (!place.address_components || !place.address_components.length > 0) {
          this.inputRef.current.placeholderText = t('enter_a_place');
        } else {
          const addrObj: PlacesResultObject = {};
          place.address_components.forEach((component) => {
            const addressType = component.types[0];
            addrObj[addressType] = component.long_name;
          });
          let responseObject = {};
          if (this.props.requiredValues && this.props.requiredValues.length > 0) {
            this.props.requiredValues.forEach((value) => {
              responseObject[value] = addrObj[value];
            });
          } else {
            const { street_number, route, locality, postal_code, administrative_area_level_1 } = addrObj;
            responseObject = { street_number, route, locality, postal_code, administrative_area_level_1 };
          }

          if (this.props.setValues) {
            this.props.setValues(responseObject);
          }
        }
      };

      autoComplete.addListener('place_changed', onPlaceChange);
    }
    window.gm_authFailure = () => {
      console.log('Error loading google places autocomplete');
      this.inputRef.current.disabled = false;
      this.inputRef.current.style = null;
      google.maps.event.clearInstanceListeners(this.inputRef.current);
      this.cleanupGooglePlacesDOM();
    };
  }

  render() {
    return (
      <div>
        <FormFieldWrapper>
          <label className={`control has-float-label ${this.props.className}`} htmlFor={'address'}>
            <input
              className={'input text-input'}
              name={'addressLine1'}
              ref={this.inputRef}
              onChange={this.props.onChange}
              value={this.props.value}
              required
              onFocus={(e) => {
                e.target.setAttribute('autocomplete', 'new-password');
              }}
              onBlur={(e) => {
                e.target.removeAttribute('autocomplete');
              }}
            />
            {this.props.label && <span className='label-text'>{this.props.label}</span>}
          </label>
        </FormFieldWrapper>
      </div>
    );
  }
}

export default withTranslation('mapInput')(compose(
  withProps({
    googleMapURL,
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: '400px' }} />
  }),
  withScriptjs
)(MapInput));



// WEBPACK FOOTER //
// ./src/components/shared/MapInput.js